
import { Component, Vue, Watch } from 'vue-property-decorator';
import BaseSidebar from '@c/layout/base-sidebar.vue';
import BaseHeader from '@c/layout/base-header.vue';
import { updateMainColorHeaderForProject } from '@t/update-main-color';
import { vxm } from '@/store/index';

@Component({
    components: {
        BaseSidebar,
        BaseHeader
    }
})
export default class App extends Vue {
    public showMenu(): boolean {
        return this.$route.name !== 'login' && this.$route.name !== 'externalValidation';
    }

    get currentProject() {
        return vxm.project.dropdownProject;
    }

    @Watch('$route')
    public routeWatcher() {
        this.updateColorForProject();
    }

    @Watch('currentProject')
    public projectWatcher() {
        this.updateColorForProject();
    }

    public updateColorForProject() {
        updateMainColorHeaderForProject(this.currentProject?.entity.label);
    }
}
